import * as React from "react";
import { BlockProps } from "baseui/block";
import { Card } from "baseui/card";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { HeadingSmall, LabelSmall } from "kanopi-components/typography";
import { HorizontalSpacer } from "kanopi-components/SpaceWrapper/HorizontalSpacer";
import { useFormatter, valueTypes } from "kw/util/useFormatter";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";

const itemProps: BlockProps = {
  justifyContent: "space-between",
  justifyItems: "stretch",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export type TStatCardValue = {
  label: string;
  value?: string;
  type?: valueTypes;
};

export type TStatCard = {
  title: string;
  summaryValue?: string;
  summaryValueType?: valueTypes;
  statistics: TStatCardValue[];
};

export const StatCard = (props: TStatCard) => {
  const { title, summaryValue, summaryValueType, statistics = [] } = props;
  const [, theme] = useStyletron();
  const { format } = useFormatter();

  return (
    <Card
      overrides={{
        Root: {
          style: {
            width: "328px",
            paddingTop: theme.sizing.scale400,
            paddingRight: theme.sizing.scale400,
            paddingBottom: theme.sizing.scale400,
            paddingLeft: theme.sizing.scale400,
            backgroundColor: theme.colors.backgroundPrimary,
            borderTopStyle: "none",
            borderRightStyle: "none",
            borderBottomStyle: "none",
            borderLeftStyle: "none",
            boxShadow: theme.lighting.shadow400,
            borderTopLeftRadius: theme.borders.radius300,
            borderTopRightRadius: theme.borders.radius300,
            borderBottomLeftRadius: theme.borders.radius300,
            borderBottomRightRadius: theme.borders.radius300,
          },
        },
      }}
    >
      <VerticalSpacer>
        <HorizontalSpacer>
          <HeadingSmall margin={0} style={{ fontWeight: "200" }}>
            {format(title, valueTypes.String)}
            {summaryValue ? ":" : null}
          </HeadingSmall>
          <HeadingSmall margin={0}>
            {format(summaryValue, summaryValueType, "")}
          </HeadingSmall>
        </HorizontalSpacer>
        <FlexGrid
          flexGridColumnCount={statistics.length}
          flexGridColumnGap={theme.sizing.scale500}
          flex={1}
        >
          {statistics.map((value, index) => {
            return (
              <FlexGridItem
                flexGridColumnCount={1}
                gridRowGap={theme.sizing.scale500}
                flex={1}
                {...itemProps}
                key={index}
                overrides={{
                  Block: {
                    style: {
                      borderRight: `1px solid ${theme.colors.borderOpaque}`,
                      ":last-child": {
                        borderRight: "none",
                        paddingRight: theme.sizing.scale0,
                      },
                      paddingRight: theme.sizing.scale500,
                    },
                  },
                }}
              >
                <LabelSmall>{format(value.label, valueTypes.String)}</LabelSmall>
                <HeadingSmall margin={0}>
                  {format(value.value, value.type)}
                </HeadingSmall>
              </FlexGridItem>
            );
          })}
        </FlexGrid>
      </VerticalSpacer>
    </Card>
  );
};
